module.exports = "<template> <address-input value.bind=field.value field.two-way=field person.bind=field.person></address-input> </template> ";